// Copyright 2025, Durable

// This sets the nonce for other scripts (tailwind, etc.) that will be imported,
// using webpack's nonce and style loader.
//
// This must preceed any other imports, so that it is applied beforehand.
import { nonce } from "./nonce.js";

import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import React from "react";

const App = React.lazy(() => import("./app"));

const render = async () => {
  // Dynamically load tailwind, since it is quite large (750KB), and this is our
  // entrypoint, so we want it to load quickly.
  //
  // @ts-expect-error
  await import("./tailwind.css")
    // Similarly, don't include this css in the bundle.
    //
    // @ts-expect-error
    .then(() => import("./index.css"))
    .then(() => import("react-dom/client"))
    .then((ReactDOM) => {
      const rootElement = document.getElementById("app");
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <CacheProvider
          value={createCache({
            key: "mui",
            nonce: nonce,
            prepend: true
          })}
        >
          <App />
        </CacheProvider>
      );
    });
};

render();
